export const clientToServerCalls = {
  getConnectionIdAsync: 'GetConnectionIdAsync',
  initializeClientAfterConnectedAsync: 'InitializeClientAfterConnectedAsync',
  requestApplicationInfoAsync: 'RequestApplicationInfoAsync',
  subscribeToUserChannelAsync: 'SubscribeToUserChannelAsync',
  presentUsersHub: {
    addDeviceAsync: 'AddDeviceAsync'
  }
};
